import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommmonService } from 'src/app/utils/common.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent implements OnChanges {
  @Output() emmiter_archivos_cargados = new EventEmitter<{
    nombres: { valor: string; corregir: boolean }[];
    listfiles: File[];
  }>();
  @Input() count_files!: boolean;
  @Input() additionalMessage?: string; // Nuevo input para mensaje adicional
  @Input() showMandatoryMessage = true;
  files: File[] = [];
  maxFiles = 5;
  invalidFileType = false;
  duplicateFile = false;
  fileTooLarge = false;
  errorMessages: string[] = [];
  allowedExtensions = ['application/pdf', 'image/jpeg', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
  maxFileSize = 5 * 1024 * 1024;
  archivos_cargados: { valor: string; corregir: boolean }[] = [];
  @Input() datos: Array<{ titulo: string; certificados: string[] }> = [];
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
      private common_service: CommmonService
    ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['datos']) {
      // Datos actualizados
    }
  }

  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const newFiles = Array.from(input.files).map((file) => {
        const file_name = `${file.name.split('.')[0]}#${this.common_service.generate_id()}.${file.name.split('.').pop()}`;
        return new File([file], file_name, { type: file.type });
      });

      this.errorMessages = [];
      const filteredFiles = this.filterValidFiles(newFiles);
      this.updateErrorFlags(newFiles, filteredFiles);
      if (this.files.length + filteredFiles.length < this.maxFiles) {
        if (!this.duplicateFile) {
          this.files = this.files.concat(filteredFiles);
          filteredFiles.forEach((file) => {
            this.archivos_cargados.push({
              valor: file.name,
              corregir: false,
            });
          });
        } else {
          setTimeout(() => {
            this.duplicateFile = false;
          }, 20000);
        }
      } else {
        const remainingSlots = this.maxFiles - this.files.length;
        if (remainingSlots > 0) {
          const filesToAdd = filteredFiles.slice(0, remainingSlots);
          this.files = this.files.concat(filesToAdd);
          filesToAdd.forEach((file) => {
            this.archivos_cargados.push({
              valor: file.name,
              corregir: false,
            });
          });
        }
        this.errorMessages.push(
          'Has alcanzado el número máximo de archivos',
        );
      }

      // Emite los archivos cargados
      this.emmiter_archivos_cargados.emit({
        nombres: this.archivos_cargados,
        listfiles: this.files,
      });

      // Resetea el input de archivo
      input.value = '';
    }
  }

  filterValidFiles(files: File[]): File[] {
    return files.filter((file) => {
      const isAllowedType = this.allowedExtensions.includes(file.type);
      const isNotDuplicate = !this.files.some(
        (existingFile) => existingFile.name.split('#')[0] === file.name.split('#')[0]
      );
      const isWithinSizeLimit = file.size <= this.maxFileSize;

      if (!isAllowedType) {
        this.errorMessages.push(`${file.name.split('#')[0]}: Tipo de archivo no permitido.`);
      } else if (!isNotDuplicate) {
        this.errorMessages.push(
          `El archivo con el nombre: ${file.name.split('#')[0]}, ya ha sido cargado.`,
        );
      } else if (!isWithinSizeLimit) {
        this.errorMessages.push(`${file.name.split('#')[0]}: Tamaño de archivo excede 5MB.`);
      }

      return isAllowedType && isNotDuplicate && isWithinSizeLimit;
    });
  }

  updateErrorFlags(newFiles: File[], filteredFiles: File[]) {
    this.invalidFileType = newFiles.length !== filteredFiles.length;
    this.duplicateFile = newFiles.some((file) =>
      this.files.some((existingFile) => existingFile.name === file.name),
    );
    this.fileTooLarge = newFiles.some((file) => file.size > this.maxFileSize);
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
    this.archivos_cargados.splice(index, 1);
  }
}
